export default __webpack_public_path__ + "static/media/gallery_05.3da26b76.jpg";